<template>
  <div>

    <svg t="1492500959545" @click="toggleClick" class="hamburger" :class="{'is-active':isActive}" style="" viewBox="0 0 1024 1024"
      version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1691" xmlns:xlink="http://www.w3.org/1999/xlink" width="72" height="72">
      <path d="M64 160.96l896 0 0 99.072-896 0 0-99.072Z" p-id="44514" fill="#0d6db7"></path>
      <path d="M64 764.032l896 0 0 99.072-896 0 0-99.072Z" p-id="44515" fill="#0d6db7"></path>
      <path d="M415.04 562.944l544.96 0 0 99.008-544.96 0 0-99.008Z" p-id="44516" fill="#0d6db7"></path>
      <path d="M415.04 361.984l544.96 0 0 99.072-544.96 0 0-99.072Z" p-id="44517" fill="#0d6db7"></path>
      <path d="M64 330.752 64 693.248 261.056 512Z" p-id="44518" fill="#0d6db7"></path>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
}
</script>

<style scoped>
  .hamburger {
    display: inline-block;
    cursor: pointer;
    width: 20px;
    height: 20px;
    transform: rotate(90deg);
    transition: .38s;
    transform-origin: 50% 50%;
  }
  .hamburger.is-active {
    transform: rotate(0deg);
  }
</style>



// WEBPACK FOOTER //
// src/components/Hamburger/index.vue